
import {
    FETCH_AUTOCLAVE_CICLO_SUBCICLO,
    FETCH_AUTOCLAVE_CICLOS,
    FETCH_AUTOCLAVE_DETALHES_CICLO, FETCH_AUTOCLAVE_HISTORICO_INDICADORES, FETCH_AUTOCLAVE_UTILIZACAODATA,
    FETCH_AUTOCLAVES, RECEIVE_AUTOCLAVE_CICLO_SUBCICLO, RECEIVE_AUTOCLAVE_CICLOS,
    RECEIVE_AUTOCLAVE_DETALHES_CICLO, RECEIVE_AUTOCLAVE_HISTORICO_INDICADORES, RECEIVE_AUTOCLAVE_UTILIZACAODATA
} from "../actions/actionTypes";
import {RECEIVE_AUTOCLAVES} from "../actions/actionTypes";

const initalState = {
    isFetchingAutoclaves: false,
    isFetchingAutoclaveUtilizacaoData: false,
    isFetchingAutoclaveCiclos: false,
    isFetchingAutoclaveSubCiclos: false,
    isFetchingAutoclavesDetalhes: false,
    AutoclavesSubCiclo: [],
    Autoclaves: [],
    AutoclaveCiclos: [],
    AutoclaveCicloOSs: [],
    isFetchingAutoclaveCicloIndicadores: false,
    ciclosDados: [],
    numAtualizacao: 0,
    utilizacaoData: []
}

export default (state = initalState, action) => {
    switch(action.type) {
        case FETCH_AUTOCLAVES:
            return {
                ...state,
                isFetchingAutoclaves: true
            }
        case RECEIVE_AUTOCLAVES:
            return {
                ...state,
                isFetchingAutoclaves: false,
                Autoclaves: action.payload
            }
        case FETCH_AUTOCLAVE_CICLOS:
            return {
                ...state,
                isFetchingAutoclaveCiclos: true,
                AutoclaveCiclos: []
            }
        case RECEIVE_AUTOCLAVE_CICLOS:
            return {
                ...state,
                isFetchingAutoclaveCiclos: false,
                AutoclaveCiclos: action.payload
            }
        case FETCH_AUTOCLAVE_CICLO_SUBCICLO:
            return {
                ...state,
                isFetchingAutoclaveSubCiclos: true
            }
        case RECEIVE_AUTOCLAVE_CICLO_SUBCICLO:
           // console.log("subciclo reducer", action.payload);
            if (action.payload.length > 0) {
                let ix = state.AutoclavesSubCiclo.findIndex(c => c.autoclaveId === action.payload[0].autoclaveId);
                let narray = state.AutoclavesSubCiclo;
                if (ix < 0) {
                    narray.push(action.payload[0]);
                } else {
                    narray[ix] = action.payload[0];
                }

                return {
                    ...state,
                    isFetchingAutoclaveSubCiclos: false,
                    AutoclavesSubCiclo: narray
                }
            } else {
                return {
                    ...state,
                    isFetchingAutoclaveCiclos: false
                }
            }


        case FETCH_AUTOCLAVE_DETALHES_CICLO:
            return {
                ...state,
                isFetchingAutoclavesDetalhes: true,
                AutoclaveCicloOSs: []
            }
        case RECEIVE_AUTOCLAVE_DETALHES_CICLO:
           // console.log("AUTOCLAVE REDUCER", action.payload);
            return {
                ...state,
                isFetchingAutoclavesDetalhes: false,
                AutoclaveCicloOSs: action.payload.data
            }
        case FETCH_AUTOCLAVE_HISTORICO_INDICADORES:
            console.log("FETCH_AUTOCLAVE_HISTORICO_INDICADORES");
            return {
                ...state,
                isFetchingAutoclaveCicloIndicadores: true
                // AutoclaveCicloIndicadores: [],
                // AutoclaveCicloEventos: [],
                // AutoclaveCicloAlarmes: []
            }
        case RECEIVE_AUTOCLAVE_HISTORICO_INDICADORES:
            console.log("RECEIVE_AUTOCLAVE_HISTORICO_INDICADORES action.payload", action.payload);
            let obs = "";
            if (state.AutoclaveCiclos.length > 0) {
              const ccc =  state.AutoclaveCiclos.find( c =>  c.autoclaveId === action.payload.autoclaveId && c.ciclo === action.payload.ciclo);
              if (typeof ccc !== "undefined" && ccc !== null) {
                  obs = ccc.observacoes;
              }
            }

            let obj = {
                autoclaveCodigo: action.payload.autoclaveCodigo,
                autoclaveId : action.payload.autoclaveId,
                ciclo: action.payload.ciclo,
                observacoes: obs,
                AutoclaveCicloIndicadores: action.payload.indicadores,
                AutoclaveCicloEventos: action.payload.eventos,
                AutoclaveCicloAlarmes: action.payload.alarmes,
                AutoclaveCicloPresets: action.payload.presets,
                AutoclaveCicloDistinctPresets: action.payload.distinctpresets,
                AutoclaveCicloTagAlarmes: action.payload.tagAlarmes || { series: [], categories: [] }
            };
            let ix = state.ciclosDados.findIndex( c => c.autoclaveId === action.payload.autoclaveId && c.ciclo === action.payload.ciclo );
            let narray = state.ciclosDados;
            if (ix < 0) {
                narray.push({...obj,  numAtualizacao: 1});
            } else {
                narray[ix] = {...obj, numAtualizacao: narray[ix].numAtualizacao + 1};
            }

            return {
                ...state,
                isFetchingAutoclaveCicloIndicadores: false,
                ciclosDados: narray,
                numAtualizacao: state.numAtualizacao + 1
            }

        case FETCH_AUTOCLAVE_UTILIZACAODATA:
            return {
                ...state,
                isFetchingAutoclaveUtilizacaoData: true,
                utilizacaoData: []
            }

        case RECEIVE_AUTOCLAVE_UTILIZACAODATA:
            console.log("RECEIVE_AUTOCLAVE_UTILIZACAODATA",action.payload)
            if (action.payload.error) {
                return {
                    ...state,
                    isFetchingAutoclaveUtilizacaoData: false,
                    utilizacaoData: []
                }
            } else {
                return {
                    ...state,
                    isFetchingAutoclaveUtilizacaoData: false,
                    utilizacaoData: action.payload
                }
            }


        default:
            return state;
    }
}
